import React from 'react';
import PropTypes from 'prop-types';
import resx from '../../utilities/resx';
import { RESX_LISTINGS } from '../../Constants';

const ListingPrice = props => {
	const {
		CurrencyCode,
		FormattedPrice,
		FormattedPricePerAmount,
		ListingTransactionType,
        ListingType,
        Price,
        PricePerAmount,
        PriceSuffix
	} = props.listing;

	// if listing is commecial and Lease (listingTransactionType === 1), show price per Sqf
    const showPricePerSqf = ListingType && ListingTransactionType && ListingType === 1 && ListingTransactionType === 1 && FormattedPricePerAmount;

    if ((showPricePerSqf && PricePerAmount === 0) || (!showPricePerSqf && Price === 0)) {
        return null;
    }

	return (
		<React.Fragment>
			{showPricePerSqf ? `${FormattedPricePerAmount}` : `${FormattedPrice}`}{' '}
			<span className={props.currencyClassName}>
				{CurrencyCode}
				{showPricePerSqf ? ` / ${resx(RESX_LISTINGS, 'SQFT')}` : ''}
				{PriceSuffix ? ` ${PriceSuffix}`: ''}
			</span>
		</React.Fragment>
	);
};

ListingPrice.propTypes = {
	listing: PropTypes.object.isRequired,
	currencyClassName: PropTypes.string
};

export default ListingPrice;
